var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showAnnouncement)?_c('div',{staticClass:"announcement"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.message)}}),_c('button',{staticClass:"close-btn",on:{"click":_vm.closeAnnouncement}},[_vm._v("Ok")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }